import React from "react";
import styled from "styled-components";

const InbioProfileContainer = styled("div")`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding-top: 24px;
  `;

  const InbioProfileTitle = styled("div")`
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    margin-top: 16px;
  `;

  const InbioDescriptionTextContainer = styled("div")`
    width: 100%;
  `;

  const InbioDescriptionContainer = styled("div")`
    position: relative;
    padding: 16px;
    margin-top: 24px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 8px;
    // box-shadow: 5px 3px 30px black;
    overflow: hidden;

    &:before {
      content: "";
      margin: -35px;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      filter: blur(10px);
      z-index: -1;
    }
  `;

  const InbioDescriptionText = styled("div")`
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    word-break: break-word;
    text-align: center;
    line-height: 24px;
    color: #111111;
  `;

export default function InbioProfileContent({ content }) {
  return (
    <InbioProfileContainer>
      {content.image ? (
        <img
          width={96}
          height={96}
          src={content.image}
          style={{ borderRadius: 100 }}
        />
      ) : (
        <div className="flex items-center justify-center w-24 h-24 bg-gray-200 rounded-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-16 h-16"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M12 11a4 4 0 100-8 4 4 0 000 8zm0-6a2 2 0 110 4 2 2 0 010-4zM12 13a7 7 0 00-7 7 1 1 0 102 0 5 5 0 1110 0 1 1 0 002 0 7 7 0 00-7-7z"
            ></path>
          </svg>
        </div>
      )}
      <InbioProfileTitle>{content.title}</InbioProfileTitle>
      {content.description && (
        <InbioDescriptionTextContainer>
          <InbioDescriptionContainer>
            <InbioDescriptionText>{content.description}</InbioDescriptionText>
          </InbioDescriptionContainer>
        </InbioDescriptionTextContainer>
      )}
    </InbioProfileContainer>
  );
}
